import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import CobaltConfigListing from './CobaltConfigListing'
import CobaltCredentialForm from './CobaltCredentialForm'

export default function CobaltPullAndPushView   (props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CobaltCredentialForm}
            PullConfigListingView={CobaltConfigListing}
        />
    )
}